import { Component, Input, Output, EventEmitter } from '@angular/core';
import { C4Param, C4ValueType } from './param-input.component';

@Component({
  selector: 'c4ParamInputs',
  templateUrl: './param-inputs.component.html'
})
export class ParamInputs {

  @Input() params: C4Param[];
  @Output() paramsChange = new EventEmitter<C4Param[]>();

  // Local version so we can do
  // change detection properly
  private _params: C4Param[];

  constructor() {

  }

  ngOnChanges() {
    this._params = (this.params || []).map(p => {

      // Set a defaults if available...
      p._value = p._value || p.value || p.default;

      return p;
    });
  }

  private changeHandler = (selected: C4ValueType, i: number) => {
    this._params[i]._value = selected.value;
    this._params[i]._display = selected.display;
    this.paramsChange.next(this._params);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/params/param-inputs.component.ts